import React, { Component } from "react";
import { Typography } from "@material-ui/core";
import BmcButton from '../bmc-button/Bmc-Button';
import Button from '@material-ui/core/Button';
import { AppName } from '../../utils/globals';

import './Sidebar.scss';

export default class Sidebar extends Component {
    constructor(props) {
        super(props);

        this.clearResults = this.clearResults.bind(this);
    }

    render() {
        return (
            <div className="Sidebar-wrapper">
                <header className="p-3">
                    <h1 className="h2">
                        {AppName}
                    </h1>

                    <Typography variant="body1">
                        Find out how much you're spending on Amazon.
                    </Typography>
                </header>

                <footer>
                    <div className="mb-3">
                        <Button onClick={this.clearResults} variant="contained">
                            Try new report
                        </Button>
                    </div>
                    { false ? (
                        <BmcButton />
                    ) : null }
                </footer>
            </div>
        )
    }

    clearResults(event) {
        this.props.onDataClear(event);
    }
}
